export function resolveStudioAgencyId(input: {
  readonly sessionAgencyId?: string | null;
  readonly configAgencyId: string;
  readonly useDevAgencyHeader: boolean;
}): string {
  const session = (input.sessionAgencyId ?? "").trim();
  if (session.length > 0) {
    return session;
  }
  if (input.useDevAgencyHeader) {
    return input.configAgencyId.trim();
  }
  return "";
}
